import { CaretRight } from '@creditornot/cb-icons';
import { cbSemanticCssVars, typographyCss } from '@creditornot/cb-ingredients';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import { localize } from 'common/utils';
import { SelectionCategory } from 'modules/shared-menu/types';

type Props = {
  category: SelectionCategory | null;
  parentCategory: SelectionCategory | undefined;
  primaryLanguage: Language;
};

const Root = styled.div`
  ${typographyCss.Heading6()};
  padding: 16px 24px;
`;

export const StyledCaretRight = styled(CaretRight)`
  width: 14px;
  margin: 0 16px;
  fill: ${cbSemanticCssVars.textPrimary};
`;

export const CategoryRow = ({ category, parentCategory, primaryLanguage }: Props) => {
  return (
    <Root>
      {category ? (
        <>
          {parentCategory && (
            <>
              {localize(parentCategory.name, primaryLanguage)}
              <StyledCaretRight />
            </>
          )}
          {localize(category.name, primaryLanguage)}
        </>
      ) : (
        <FormattedMessage id="menu.nonCategorised" />
      )}
    </Root>
  );
};
